import { Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { FieldErrorDto } from "../../../../../../autogen/bff-api";

interface Props {
  error: FieldErrorDto;
}

export const FieldErrorBox = ({ error }: Props) => {
  const { t } = useTranslation();
  return (
    <Box
      borderWidth="1px"
      borderColor="smErrorSoftBorder"
      bg="smErrorSoft"
      borderRadius="md"
      px={3}
      py={2}
      mt={1}
    >
      <Text color="smErrorStrong" fontSize="sm" fontWeight="600">
        {t(error.code, error.params ?? {})}
      </Text>
    </Box>
  );
};
